import { render, staticRenderFns } from "./LoanDetailsModal.vue?vue&type=template&id=1b6c5964"
import script from "./LoanDetailsModal.vue?vue&type=script&lang=js"
export * from "./LoanDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports